import { api } from "../api";

export const adspressoAnalytics = api.injectEndpoints({
    endpoints: (builder) => ({
        getAdspressoUsers: builder.query({
            query: () => ({
                url: `/connect-bm/dashboard/users/count`,
            }),
            transformResponse: (response, meta, arg) => response,
        }),
        getAdspressoCampaignsLaunched: builder.query({
            query: () => ({
                url: `/adspresso/tracklist/dashboard/summary`,
            }),
            transformResponse: (response, meta, arg) => response.data,
        }),
        getAdspressoAdaccounts: builder.query({
            query: () => ({
                url: `/adspresso/tracklist/dashboard/adaccounts`,
            }),
            transformResponse: (response, meta, arg) => response.data,
        }),
        getAdAccountsCampaigns: builder.query({
          query: ({ currentPage, filters }) => {
            let queryString = `/adspresso/tracklist/dashboard/adaccounts_camapaigns`;

            const hasValidFilters = filters && (
              (Array.isArray(filters) && filters.length > 0) ||
              (typeof filters === 'object' && Object.keys(filters).length > 0)
            );
            
            if (hasValidFilters) {
              queryString += '?';
              const params = [];
        
              Object.keys(filters).forEach((key) => {
                const value = filters[key];
                if (value !== undefined && value !== null) {
                  if (Array.isArray(value)) {
                    params.push(`${key}=${encodeURIComponent(JSON.stringify(value))}`);
                  } else {
                    params.push(`${key}=${encodeURIComponent(value)}`);
                  }
                }
              });
        
              queryString += params.join('&');
            } else {
              // Only add currentPage if filters are not present
              queryString += `?page=${currentPage}`;
            }
        
            return queryString;
          },
          transformResponse: (response) => response.data,
          providesTags: ['AdspressoAnalytics'],
        }),             
        getActiveCampaigns: builder.query({
            query: () => `/adspresso/tracklist/dashboard/active_campaigns`,
            transformResponse: (response, meta, arg) => response.data,
            providesTags: ['AdspressoAnalytics'],
        }),
        getTotalSpend: builder.query({
          query: ({ filters }) => {
            const params = new URLSearchParams();
        
            if (filters) {
              Object.keys(filters).forEach((key) => {
                const value = filters[key];
                if (value !== undefined && value !== null) {
                  if (Array.isArray(value)) {
                    // Convert array to JSON string and encode
                    params.append(key, JSON.stringify(value));
                  } else {
                    params.append(key, value);
                  }
                }
              });
            }
        
            const queryString = params.toString();
            return queryString 
              ? `/adspresso/tracklist/dashboard/total-spend?${queryString}` 
              : '/adspresso/tracklist/dashboard/total-spend';
          },
          transformResponse: (response) => response.data,
          providesTags: ['AdspressoAnalytics'],
        }),                
        getUpdateTracklist: builder.mutation({
            query: () => ({
                url: '/adspresso/tracklist/dashboard/update-tracklist',
                method: 'POST',
            }),
            transformResponse: (response, meta, arg) => response.data,
            invalidatesTags: ['AdspressoAnalytics'],
        }),        
    }),
});

export const { useGetAdspressoCampaignsLaunchedQuery, useGetAdspressoUsersQuery, useGetAdspressoAdaccountsQuery, useGetAdAccountsCampaignsQuery, useGetActiveCampaignsQuery, useGetTotalSpendQuery, useGetUpdateTracklistMutation } = adspressoAnalytics;
